/** @format */

import React from 'react';

import { Link } from 'react-router-dom';

export default function BrokerProfileHeader(props) {
  const { tprop, address, brokerProfileUrl, title, brokerDetails } = props;

  return (
    <div className='object-listing-header'>
      <div className='object-listing-header-left'>
        <div className='object-listing-header-top'>
          <h3>{title}</h3>
        </div>
        <div className='object-listing-header-bottom'>
          <div className='object-listing-header-icon icon-location'></div>
          <div className='object-listing-header-address text2r'>{address}</div>
        </div>
      </div>
      <div className='object-listing-header-right'>
        <div className='object-listing-header-top'>
          <span className='text2r'>{tprop.soldBy.text}</span>
          <Link to={brokerProfileUrl}>
            {brokerDetails.firstName + ' ' + brokerDetails.lastName}
          </Link>
        </div>
        <div className='object-listing-header-bottom'>
          <div className='contact-icons-container'>
            <a
              href={`tel:${brokerDetails.phoneNumber}`}
              className='contact-icons-container-left icon-phone-pink'></a>
            <a
              href={`mailto:${brokerDetails.email}`}
              className='contact-icons-container-right icon-email-pink'></a>
          </div>
        </div>
      </div>
    </div>
  );
}
